import OrderTypeLayout from "@/pages/order-type/components/OrderTypeLayout";

export default function LimitOrders() {
  return <OrderTypeLayout slug="limit-orders" />;
}